import { connect } from 'react-redux';
import { keepSeasonInfo } from 'redux-core/productions/actions';

const mapDispatchToProps = {
  keepSeasonInfo,
};

export default connect(null, mapDispatchToProps);
